import { OrderApiClient } from '@fourthwall/services/dist/OrderApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useCalculateItemsReplacementsQuery = createQueryHook(
  OrderApiClient.calculateItemsReplacements,
  {
    queryKey: ['calculateItemsReplacements'],
  },
)
